import Loadable from "app/components/Loadable";
import { lazy } from "react";

const Home = Loadable(lazy(() => import("./Home")));
const Create = Loadable(lazy(() => import("./Create")));
const Search = Loadable(lazy(() => import("./Search")));
 const Message = Loadable(lazy(() => import('./ChatMessage')));
const Notification = Loadable(lazy(() => import('./Notification')));
// const ArtiztOs = Loadable(lazy(() => import('./ArtiztOs')));
// const MessageChat = Loadable(lazy(() => import('./MessageChat')));
// const ProfileDetail = Loadable(lazy(() => import('./ProfileDetail')));
// const ApplyScreen = Loadable(lazy(() => import('./ApplyScreen')));
// const ApplicationSuccess = Loadable(lazy(() => import('./ApplicationSuccess')));
// const GroupChat = Loadable(lazy(() => import('./GroupChat')));
const GigGetbyID = Loadable(lazy(() => import("./GigGetByID")));
const CreateProject = Loadable(lazy(() => import("./CreateProject")));
// const SearchViewAll = Loadable(lazy(() => import('./SearchIndividual')));
// const GroupChatMemberList = Loadable(lazy(() => import('./GroupChatMemberList')));
const AddPostFeedV1 = Loadable(lazy(() => import("./AddPostFeedv1")));
const AddinternShipv1 = Loadable(lazy(() => import("./AddinternShipv1")));
const Addapprenticeshipv1 = Loadable(
  lazy(() => import("./Addapprenticeshipv1"))
);
const InternShipByD=Loadable(lazy(() => import("./GetInternShipByID")));
const Addgigworkv1 = Loadable(lazy(() => import("./Addgigworkv1")));

const GroupChatMemberList = Loadable(lazy(() => import('./GroupChatMemberList')));
const AddProjectv1 = Loadable(lazy(() => import("./AddProjectv1")));
// const GetProjectByIDv1 = Loadable(lazy(() => import("./GetProjectByID")));
const AddJob = Loadable(lazy(() => import("./Job")));

const AddprojCollaboratorsv1 = Loadable(
  lazy(() => import("./AddprojCollaboratorsv1"))
);
const ApprenticeShipByID = Loadable(lazy(() => import("./GetApprenticeShipByID")));
const Addendorsementv1 = Loadable(lazy(() => import("./Addendorsementv1")));

const AddExpEndorseListData = Loadable(
  lazy(() => import("./AddExpEndorseListData"))
);
const JobGetByID = Loadable(
  lazy(() => import("./JobGetByID"))
);
const ProjectOptions = Loadable(
  lazy(() => import("./ProjectOptions"))
);

const SetupProjects = Loadable(lazy(() => import("./SetupProjects")));


const homeroutes = [
  { path: "/home", element: <Home /> },
  { path: "/home/create", element: <Create /> },
  { path: "/home/search", element: <Search /> },
  { path: '/home/message', element: <Message /> },
    { path: '/home/notification', element: <Notification /> },
  //   { path: '/home/artizt-os', element: <ArtiztOs /> },
  //   { path: '/home/personal-message/:id', element: <MessageChat /> },
  //   { path: '/home/profile-detail', element: <ProfileDetail /> },
  //   { path: '/home/apply-screen', element: <ApplyScreen /> },
  //   { path: '/home/application-success', element: <ApplicationSuccess /> },
  //   { path: '/home/group-message/:id', element: <GroupChat /> },
  { path: "/home/create/create-project", element: <CreateProject /> },
  //   { path: '/home/search/:screenName', element: <SearchViewAll /> },
     { path: '/home/group-message/member-list/:id', element: <GroupChatMemberList /> },

  { path: "/home/AddPostFeedV1", element: <AddPostFeedV1 /> },
  { path: "/home/AddinternShipv1", element: <AddinternShipv1 /> },
  { path: "/home/Addapprenticeshipv1", element: <Addapprenticeshipv1 /> },
  { path: "/home/Addgigworkv1", element: <Addgigworkv1 /> },
  { path: "/home/AddProjectv1", element: <AddProjectv1 /> },
  { path: "/home/AddprojCollaboratorsv1", element: <AddprojCollaboratorsv1 /> },
 { path: "/home/AddinternShipv1/:mode/:id", element: <InternShipByD /> },
  { path: "/home/Addapprenticeshipv1/:mode/:id", element: <ApprenticeShipByID /> },
  { path: "/home/Addgigworkv1/:mode/:id", element: <GigGetbyID /> },
  { path: "/home/Addendorsementv1", element: <Addendorsementv1 /> },
  { path: "/home/AddExpEndorseListData", element: <AddExpEndorseListData /> },
  { path: "/home/AddJob", element: <AddJob /> },
    { path: "/home/AddJob/:mode/:id", element: <JobGetByID /> },
    //  { path: "/home/get-project/:mode/:id", element: <GetProjectByIDv1 /> },

  { path: "/home/ProjectOptions", element: <ProjectOptions /> },
  { path: "/home/SetupProjects", element: <SetupProjects /> },

  ];

export default homeroutes;
